import React from 'react';
import styled from '@emotion/styled';
import { media, mediaQueries } from '../../../style/global-style';

export const StyledExclusivesOuterWrapper = styled(({ color, ...rest }: { color: string }) => (
    <div {...rest} />
))`
    color: ${(props) => props.color};

    .highlightBarCard {
        padding: 0;
        margin: 0 0 15px;
        width: auto;

        @media ${mediaQueries.tabletAndUp} {
            margin: 0 auto 15px;
        }
    }
`;

export const StyledExclusivesInnerWrapper = styled.div`
    background-color: ${(props) => props.theme.shades.white};
    border: 1px solid ${(props) => props.color};
    width: 265px;
    margin: 0 auto;
    padding: 12px;
    display: flex;

    ${media.tablet`
        padding: 20px 20px 10px;
        width: 100%;
    `}
`;

export const StyledArrowText = styled.span`
    padding: 0 9px;
    font-size: ${(props) => props.theme.fontSize.copyTextL};
`;

export const StyledLabelledArrowWrapper = styled.div`
    position: relative;
    top: 11px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.shades.white};
    font-weight: 500;
`;
